<template>
  <b-overlay :show="show" rounded="sm">
    <b-col md="12" sm="12" v-if="load">
      <b-card no-body class="mx-4">
        <b-card-body class="p-12">
          <h1 tabindex="0"> {{ form.titulo }}</h1>
          <b-row>
            <b-col cols="12">
              <div tabindex="0" v-html="form.descricao"></div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <b-card no-body class="mx-4" v-for="(proposta, index) in form.propostas" :key="proposta.id">
        <b-card-body class="p-12">
          <b-row>
            <b-col cols="12">
              <div tabindex="0" v-html="proposta.texto"></div>
            </b-col>
          </b-row>
        </b-card-body>
        <b-card-footer class="p-12">
          <b-row>
            <b-col v-if="(form.acao_editar || form.acao_emenda) && acao_perfil_editar && form.situacao !== 'S'" 
              style="padding-bottom: 5px;" sm="12" md="12" lg="6">
              <b-button block variant="secondary" @click="loadModalSugestaoEdicao(index)">
                <i class="fa fa-pencil"></i>&nbsp;
                <span>Sugerir Edição</span>
                <span class="badge badge-light">{{ proposta.emendas.length }}</span>
              </b-button>
            </b-col>
            <b-col
              v-else-if="perfil.is_admin_conferencia || (form.visivel_encerrado && form.situacao === 'S' && acao_perfil_editar)" 
              style="padding-bottom: 5px;" sm="12" md="12" lg="6">
              <b-button block variant="secondary" @click="loadModalVisualizarSugestaoEdicao(index)">
                <i class="fa fa-pencil"></i>&nbsp;
                <span>Visualizar Edição</span>
                <span class="badge badge-light">{{ proposta.emendas.length }}</span>
              </b-button>
            </b-col>
            <b-col v-if="form.acao_priorizar && acao_perfil_priorizar && form.situacao !== 'S'" 
            style="padding-bottom: 5px;" sm="12" md="12" lg="6">
              <b-button block variant="secondary" @click="loadModalPriorizar(index)">
                <i class="fa fa-check"></i>&nbsp;
                <span v-if="proposta.priorizacaoUser == 0 && proposta.travaPriorizar">Priorizar</span>
                <span v-if="proposta.priorizacaoUser > 0 || !proposta.travaPriorizar">Visualizar Priorização</span>
                <span class="badge badge-light">{{ proposta.totalPriorizacao }}</span>
              </b-button>
            </b-col>
            <b-col
              v-else-if="perfil.is_admin_conferencia || (form.visivel_encerrado && form.situacao === 'S' && acao_perfil_priorizar)" 
              style="padding-bottom: 5px;" sm="12" md="12" lg="6">
              <b-button block variant="secondary" @click="loadModalPriorizar(index)">
                <i class="fa fa-check"></i>&nbsp;
                <span>Visualizar Priorização</span>
                <span class="badge badge-light">{{ proposta.totalPriorizacao }}</span>
              </b-button>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col v-if="form.acao_aprovar && acao_perfil_aprovar && form.situacao !== 'S'" 
            style="padding-bottom: 5px;" sm="12" md="12" lg="6">
              <b-button block variant="secondary" @click="loadModalAprovarOriginal(index)">
                <i class="fa fa-check"></i>&nbsp;
                <span v-if="proposta.votacaoOriginalUser == 0 && proposta.votacaoAlteradoUser == 0">Aprovar</span>
                <span v-if="proposta.votacaoOriginalUser > 0 || proposta.votacaoAlteradoUser > 0">Visualizar
                  Aprovações</span>
                <span class="badge badge-light">{{ proposta.totalVotacaoOriginal }}</span>
              </b-button>
            </b-col>
            <b-col
              v-else-if="perfil.is_admin_conferencia || (form.visivel_encerrado && form.situacao === 'S' && acao_perfil_aprovar)"
              style="padding-bottom: 5px;" sm="12" md="12" lg="6">
              <b-button block variant="secondary" @click="loadModalAprovarOriginal(index)">
                <i class="fa fa-check"></i>&nbsp;
                <span>Visualizar Aprovações</span>
                <span class="badge badge-light">{{ proposta.totalVotacaoOriginal }}</span>
              </b-button>
            </b-col>
            <b-col v-if="form.acao_aprovar && acao_perfil_aprovar && form.situacao !== 'S'" 
            style="padding-bottom: 5px;" sm="12" md="12" lg="6">
              <b-button block variant="secondary" @click="loadModalAprovarAlterado(index)">
                <i class="fa fa-check"></i>&nbsp;
                <span></span>
                <span v-if="proposta.votacaoAlteradoUser == 0 && proposta.votacaoOriginalUser == 0">Rejeitar</span>
                <span v-if="proposta.votacaoAlteradoUser > 0 || proposta.votacaoOriginalUser > 0">Visualizar
                  Rejeições</span>
                <span class="badge badge-light">{{ proposta.totalVotacaoAlterado }}</span>
              </b-button>
            </b-col>
            <b-col
              v-else-if="perfil.is_admin_conferencia || (form.visivel_encerrado && form.situacao === 'S' && acao_perfil_aprovar)"
              style="padding-bottom: 5px;" sm="12" md="12" lg="6">
              <b-button block variant="secondary" @click="loadModalAprovarAlterado(index)">
                <i class="fa fa-check"></i>&nbsp;
                <span></span>
                <span>Visualizar Rejeições</span>
                <span class="badge badge-light">{{ proposta.totalVotacaoAlterado }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
      <b-card no-body class="mx-4">
        <b-row>
          <b-col class="col-sm-12">
            <div style="background-color: #FAAF40; padding-top: 5px; padding-bottom: 1px;">
              <p tabindex="0" style="font-size: 16px">&nbsp;<strong>Mensagens</strong></p>
            </div>
            <b-card style="height: 300px; overflow: auto;">
              <ul v-if="form.comentarios.length > 0">
                <li v-for="comentario in form.comentarios" :key="comentario.id">
                  <strong>{{ comentario.user.nome }} - {{ comentario.created_at }}</strong><br>
                  <div class="p-3 mb-2 bg-primary text-white" style="border-radius: 10px; width: 50%;">{{ comentario.texto
                  }}</div>
                </li>
              </ul>
              <ul v-else>
                <li>
                  <i tabindex="0">Nenhuma mensagem.</i>
                </li>
              </ul>
              <b-row>
                <b-col cols="12" style="padding-bottom: 5px;">
                  <b-form-textarea placeholder="Digite sua mensagem" tabindex="0" id="textarea" rows="3"
                    v-model="comentario"></b-form-textarea>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="4" align-self="end">
                  <b-button block variant="success" @click="enviarComentario()">
                    <i class="fa fa-paper-plane-o" aria-hidden="true"></i>&nbsp;&nbsp;<span>Enviar</span>
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
      <b-card no-body class="mx-4">
        <b-card-footer class="p-12">
          <b-row>
            <b-col sm="12" md="4" lg="3">
              <b-button block variant="secondary" @click="$router.go(-1)">
                <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>

      <b-modal :title="'Sugerir Alteração de Texto'" scrollable size="lg" ok-title="Enviar Sugestão" cancel-title="Cancelar" v-model="modalSugestaoEdicao" @ok="enviarSugestaoEdicao()">
        <b-card-body>
          <b-row>
            <b-col cols="4">
              <strong tabindex="0">Texto Atual:</strong>
            </b-col>
            <b-col cols="8">
              <div tabindex="0" v-html="textoAtualSugestao" />
            </b-col>
          </b-row>
          <hr>
          <b-form>
            <b-row style="margin-top: 10px; margin-bottom: 25px" v-if="form.acao_editar">
              <b-col cols="12">
                <h3 tabindex="0" style="color: #339966; margin-bottom: 20px; font-weight: bold; text-align: center">
                  INSIRA AQUI SUA SUGESTÃO</h3>
              </b-col>
              <b-col cols="12">
                <b-form-textarea tabindex="0" id="textarea" rows="8" v-model="sugestaoEdicao"
                  placeholder="Sugiro a edição desse artigo"></b-form-textarea>
              </b-col>
            </b-row>
            <span v-if="emendas.length > 0">
              <b-row v-for="emenda in emendas" :key="emenda.id">
                <b-col md="12" sm="12">
                  <b-card no-body>
                    <b-card-body class="p-12">
                      <b-row>
                        <b-col tabindex="0" cols="9">
                          <strong>Usuário: </strong> {{ emenda.user_emenda.nome }}
                        </b-col>
                        <b-col tabindex="0" cols="3">
                          <!-- <i>{{ edicao.created_at }}</i> -->
                        </b-col>
                      </b-row>
                      <b-row style="margin-top: 10px">
                        <b-col tabindex="0" cols="4">
                          <strong>Sugestão de Alteração:</strong>
                        </b-col>
                        <b-col cols="8">
                          <div tabindex="0" v-html="emenda.texto"></div>
                        </b-col>
                      </b-row>
                      <div v-if="form.acao_emenda">
                        <b-row>
                          <b-col cols="8"></b-col>
                          <b-col v-if="emenda.votoUser == 0" cols="4">
                            <b-button class="btn btn-sm btn-success action" title="Aprovar"
                              @click="aprovarEmenda(emenda.id)">
                              Aprovar
                            </b-button>
                            <b-button class="btn btn-sm btn-warning action" title="Rejeitar"
                              @click="rejeitarEmenda(emenda.id)">
                              Rejeitar
                            </b-button>
                          </b-col>
                        </b-row>
                        <hr>
                        <b-row>
                          <b-col cols="12" style="text-align: center">
                            <h5 tabindex="0"><strong>Aprovada Por</strong></h5>
                          </b-col>
                        </b-row>
                        <hr>
                        <b-form>
                          <span v-if="emenda.votosAprovadosEmenda > 0">
                            <b-row>
                              <b-col tabindex="0" md="12" sm="12">
                                <ul>
                                  <li v-for="(votos) in emenda.votos" :key="votos.id" v-show="votos.aprovado == true">
                                    {{ votos.user.nome }} - {{ votos.created_at }}
                                  </li>
                                </ul>
                              </b-col>
                            </b-row>
                            <b-row style="margin-top: 2px">
                              <b-col tabindex="0" cols="12">
                                <strong>Total de Aprovados:</strong> {{ emenda.votosAprovadosEmenda }}
                              </b-col>
                            </b-row>
                          </span>
                          <span tabindex="0" v-else><i>Nenhuma votação registrada</i></span>
                        </b-form>
                        <hr>
                        <b-row>
                          <b-col cols="12" style="text-align: center">
                            <h5 tabindex="0"><strong>Rejeitado Por</strong></h5>
                          </b-col>
                        </b-row>
                        <hr>
                        <b-form>
                          <span v-if="emenda.votosRejeitadosEmenda > 0">
                            <b-row>
                              <b-col tabindex="0" md="12" sm="12">
                                <ul>
                                  <li v-for="(votos) in emenda.votos" :key="votos.id" v-show="votos.aprovado == false">
                                    {{ votos.user.nome }} - {{ votos.created_at }}
                                  </li>
                                </ul>
                              </b-col>
                            </b-row>
                            <b-row style="margin-top: 2px">
                              <b-col tabindex="0" cols="12">
                                <strong>Total de Rejeitados:</strong> {{ emenda.votosRejeitadosEmenda }}
                              </b-col>
                            </b-row>
                          </span>
                          <span tabindex="0" v-else><i>Nenhuma votação registrada</i></span>
                        </b-form>
                      </div>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </span>
          </b-form>
        </b-card-body>
      </b-modal>

      <b-modal :title="'Visualizar Alteração de Texto'" size="lg" ok-only v-model="modalVisualizarSugestaoEdicao">
        <b-card-body>
          <b-row>
            <b-col tabindex="0" cols="4">
              <strong>Texto Atual:</strong>
            </b-col>
            <b-col cols="8">
              <div tabindex="0" v-html="textoAtualSugestao" />
            </b-col>
          </b-row>
          <hr>
          <b-form>
            <span v-if="emendas.length > 0">
              <b-row v-for="emenda in emendas" :key="emenda.id">
                <b-col md="12" sm="12">
                  <b-card no-body>
                    <b-card-body class="p-12">
                      <b-row>
                        <b-col tabindex="0" cols="9">
                          <strong>Usuário: </strong> {{ emenda.user_emenda.nome }}
                        </b-col>
                        <b-col tabindex="0" cols="3">
                          <!-- <i>{{ edicao.created_at }}</i> -->
                        </b-col>
                      </b-row>
                      <b-row style="margin-top: 10px">
                        <b-col tabindex="0" cols="4">
                          <strong>Sugestão de Alteração:</strong>
                        </b-col>
                        <b-col cols="8">
                          <div tabindex="0" v-html="emenda.texto"></div>
                        </b-col>
                      </b-row>
                      <hr>
                      <b-row>
                        <b-col cols="12" style="text-align: center">
                          <h5 tabindex="0"><strong>Aprovada Por</strong></h5>
                        </b-col>
                      </b-row>
                      <hr>
                      <b-form>
                        <span v-if="emenda.votosAprovadosEmenda > 0">
                          <b-row>
                            <b-col tabindex="0" md="12" sm="12">
                              <ul>
                                <li v-for="(votos) in emenda.votos" :key="votos.id" v-show="votos.aprovado == true">
                                  {{ votos.user.nome }} - {{ votos.created_at }}
                                </li>
                              </ul>
                            </b-col>
                          </b-row>
                          <b-row style="margin-top: 2px">
                            <b-col tabindex="0" cols="12">
                              <strong>Total de Aprovados:</strong> {{ emenda.votosAprovadosEmenda }}
                            </b-col>
                          </b-row>
                        </span>
                        <span tabindex="0" v-else><i>Nenhuma votação registrada</i></span>
                      </b-form>
                      <hr>
                      <b-row>
                        <b-col cols="12" style="text-align: center">
                          <h5 tabindex="0"><strong>Rejeitado Por</strong></h5>
                        </b-col>
                      </b-row>
                      <hr>
                      <b-form>
                        <span v-if="emenda.votosRejeitadosEmenda > 0">
                          <b-row>
                            <b-col tabindex="0" md="12" sm="12">
                              <ul>
                                <li v-for="(votos) in emenda.votos" :key="votos.id" v-show="votos.aprovado == false">
                                  {{ votos.user.nome }} - {{ votos.created_at }}
                                </li>
                              </ul>
                            </b-col>
                          </b-row>
                          <b-row style="margin-top: 2px">
                            <b-col tabindex="0" cols="12">
                              <strong>Total de Rejeitados:</strong> {{ emenda.votosRejeitadosEmenda }}
                            </b-col>
                          </b-row>
                        </span>
                        <span tabindex="0" v-else><i>Nenhuma votação registrada</i></span>
                      </b-form>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </span>
          </b-form>
        </b-card-body>
      </b-modal>

      <b-modal title="Incluir Comentários" size="lg" cancel-title="Cancelar" v-model="modalComentario"
        @ok="enviarComentario()">
        <b-card-body>
          <b-form>
            <b-row>
              <b-col cols="12">
                <h3 tabindex="0" style="color: #339966; margin-bottom: 20px; font-weight: bold; text-align: center">Insira
                  aqui seu Comentário</h3>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="2">
                <strong tabindex="0">Comentário:</strong>
              </b-col>
              <b-col cols="10">
                <b-form-textarea tabindex="0" id="textarea" rows="8" v-model="comentario"></b-form-textarea>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
      </b-modal>

      <b-modal title="Visualizar Votação" size="lg" v-model="modalAprovarOriginal" @ok="cancelar()" ok-only>
        <b-card-body>
          <b-row>
            <b-col cols="12">
              <div tabindex="0" v-html="propostaOriginal.texto" />
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col cols="12" style="text-align: center">
              <h5 tabindex="0"><strong>Aprovada Por</strong></h5>
            </b-col>
          </b-row>
          <hr>
          <b-form>
            <p><strong> Total Aprovados: {{ avaliacoes.data !== undefined ? avaliacoes.data.length : '0' }} </strong></p>
            <span v-if="avaliacoes.data !== undefined">
              <b-row>
                <b-col tabindex="0" md="12" sm="12">
                  <ul>
                    <li v-for="(avaliacao) in avaliacoes.data" :key="avaliacao.id">
                      {{ avaliacao.nome_social ? avaliacao.nome_social : avaliacao.usuario }} - {{ avaliacao.created_at }}
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </span>
            <span tabindex="0" v-else><i>Nenhuma votação registrada</i></span>
            <pagination v-show="avaliacoes.data !== undefined" :totalPorPagina="5" :resource="resourceAvaliacoes"
              :filtros="filtros"></pagination>
            <hr>
            <b-row
              v-if="propostaOriginal.votacaoOriginalUser == 0 && propostaAlterada.votacaoAlteradoUser == 0 && form.acao_aprovar && acao_perfil_aprovar && form.situacao !== 'S'">
              <b-col md="12" sm="12">
                <p tabindex="0" style="text-align: center"><strong>Confirme seu voto aqui:</strong></p><br>
              </b-col>
              <b-col offset="2" md="4" sm="4">
                <b-button block variant="success" @click="aprovarPropostaOriginal()" :disabled="loading">
                  <i class="fa fa-check"></i>&nbsp;&nbsp;<span>Aprovar</span>
                </b-button>
              </b-col>
              <b-col md="4" sm="4">
                <b-button block variant="secondary" @click="cancelar()">
                  <span>Voltar</span>
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
      </b-modal>

      <b-modal title="Visualizar Votação" size="lg" v-model="modalAprovarAlterado" @ok="cancelar()" ok-only>
        <b-card-body>
          <b-row>
            <b-col cols="12">
              <div tabindex="0" v-html="propostaAlterada.texto" />
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col cols="12" style="text-align: center">
              <h5 tabindex="0"><strong>Rejeitado Por</strong></h5>
            </b-col>
          </b-row>
          <hr>
          <b-form>
            <p><strong> Total Rejeitados: {{ avaliacoes.data !== undefined ? avaliacoes.data.length : '0' }} </strong></p>
            <span v-if="avaliacoes.data !== undefined">
              <b-row>
                <b-col tabindex="0" md="12" sm="12">
                  <ul>
                    <li v-for="(avaliacao) in avaliacoes.data" :key="avaliacao.id">
                      {{ avaliacao.nome_social ? avaliacao.nome_social : avaliacao.usuario }} - {{ avaliacao.created_at }}
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </span>
            <span tabindex="0" v-else><i>Nenhuma votação registrada</i></span>
            <pagination tabindex="0" v-show="avaliacoes.data !== undefined" :totalPorPagina="5"
              :resource="resourceAvaliacoes" :filtros="filtros"></pagination>
            <hr>
            <b-row
              v-if="propostaAlterada.votacaoAlteradoUser == 0 && propostaOriginal.votacaoOriginalUser == 0 && form.acao_aprovar && acao_perfil_aprovar && form.situacao !== 'S'">
              <b-col md="12" sm="12">
                <p tabindex="0" style="text-align: center"><strong>Confirme seu voto aqui:</strong></p><br>
              </b-col>
              <b-col offset="2" md="4" sm="4">
                <b-button block variant="success" @click="aprovarPropostaAlterada()" :disabled="loading">
                  <i class="fa fa-check"></i>&nbsp;&nbsp;<span>Rejeitar</span>
                </b-button>
              </b-col>
              <b-col md="4" sm="4">
                <b-button block variant="secondary" @click="cancelar()">
                  <span>Voltar</span>
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
      </b-modal>

      <b-modal title="Visualizar Priorização" size="lg" v-model="modalPriorizar" @ok="cancelar()" ok-only>
        <b-card-body>
          <b-row>
            <b-col cols="12">
              <div tabindex="0" v-html="propostaPrioriazada.texto" />
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col cols="12" style="text-align: center">
              <h5 tabindex="0"><strong>Priorizada Por</strong></h5>
            </b-col>
          </b-row>
          <hr>
          <b-form>
            <p><strong> Total Priorizados: {{ avaliacoes.data !== undefined ? avaliacoes.data.length : '0' }} </strong>
            </p>
            <span v-if="avaliacoes.data !== undefined">
              <b-row>
                <b-col tabindex="0" md="12" sm="12">
                  <ul>
                    <li v-for="(avaliacao) in avaliacoes.data" :key="avaliacao.id">
                      {{ avaliacao.nome_social ? avaliacao.nome_social : avaliacao.usuario }} - {{ avaliacao.created_at }}
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </span>
            <span tabindex="0" v-else><i>Nenhuma votação registrada</i></span>
            <pagination v-show="avaliacoes.data !== undefined" :totalPorPagina="5" :resource="resourceAvaliacoes"
              :filtros="filtros"></pagination>
            <hr>
            <b-row
              v-if="propostaPrioriazada.priorizacaoUser == 0 && form.acao_priorizar && acao_perfil_priorizar && propostaPrioriazada.travaPriorizar && form.situacao !== 'S'">
              <b-col md="12" sm="12">
                <p tabindex="0" style="text-align: center"><strong>Deseja realmente priorizar essa proposta?</strong></p>
                <br>
              </b-col>
              <b-col offset="2" md="4" sm="4">
                <b-button block variant="success" @click="priorizarProposta()" :disabled="loading">
                  <i class="fa fa-check"></i>&nbsp;&nbsp;<span>Priorizar</span>
                </b-button>
              </b-col>
              <b-col md="4" sm="4">
                <b-button block variant="secondary" @click="cancelar()">
                  <span>Voltar</span>
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
      </b-modal>

    </b-col>
    <b-col md="12" sm="12" v-else>
      <b-card no-body class="mx-4">
        <b-card-body class="p-12">
          <h1 tabindex="0">Caderno de Proposta</h1>
          <b-row>
            <b-col cols="12">
              <p tabindex="0" style="text-align: center">Carregando...</p>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>
  </b-overlay>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import VueSelect from 'vue-select'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import SessionStorage from '@/services/session-storage'
import { eventType } from '@/components/shared/eventType'

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    Pagination,
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      titulo: {
        required
      },
      descricao: {
        required
      }
    }
  },
  created() {
    this.buscaPermissoesFormulario()
    this.perfilUser = SessionStorage.get('perfil_atual_id')
  },
  data() {
    return {
      loading: false,
      show: false,
      conferencia_id: SessionStorage.get('conferencia_atual_id'),
      usuario_id: SessionStorage.get('usuario'),
      form: {
        id: '',
        titulo: '',
        descricao: '',
        eixo: '',
        propostas: [],
        comentarios: []
      },
      filtros: {
        tipo: null
      },
      perfilUser: null,
      eixoUser: null,
      acao_perfil_editar: false,
      acao_perfil_aprovar: false,
      acao_perfil_priorizar: false,
      load: false,
      propostaAtual: null,
      emendas: [],
      modalComentario: false,
      textoAtualSugestao: '',
      sugestaoEdicao: '',
      comentario: '',
      resourceSugestao: '',
      resourceComentario: '',
      modalSugestaoEdicao: false,
      modalVisualizarSugestaoEdicao: false,
      modalAprovarOriginal: false,
      modalAprovarAlterado: false,
      modalPriorizar: false,
      propostaOriginal: [],
      propostaAlterada: [],
      propostaPrioriazada: [],
      perguntas_respostas: [],
      resourceAvaliacoes: '',
      indiceSugestao: null,
      usuarioAtual: 0,
      disable_buttons: false,
      titulo_toast: 'Alerta!',
      salvarForm: false
    }
  },
  computed: {
    avaliacoes() {
      return this.$store.state.pagination.getList
    },
    edicoes() {
      return this.$store.state.pagination.getList
    },
    exclusoes() {
      return this.$store.state.pagination.getList
    },
    comentarios() {
      return this.$store.state.pagination.getList
    },
    isValid() {
      return !this.$v.form.$anyError
    },
    isValidSelection() {
      return this.selected !== '' && this.selected !== 'forbidden value'
    },
    perfil() {
      return this.$store.state.perfil.perfil
    }
  },
  methods: {
    loadModalComentarios() {
      this.modalComentario = true
      this.comentario = ''
    },
    loadModalSugestaoEdicao(index) {
      this.propostaAtual = this.form.propostas[index].id
      this.textoAtualSugestao = this.form.propostas[index].texto
      this.emendas = this.form.propostas[index].emendas
      this.sugestaoEdicao = ''
      this.modalSugestaoEdicao = true
      this.indiceSugestao = index
    },
    loadModalVisualizarSugestaoEdicao(index) {
      this.propostaAtual = this.form.propostas[index].id
      this.textoAtualSugestao = this.form.propostas[index].texto
      this.emendas = this.form.propostas[index].emendas
      this.sugestaoEdicao = ''
      this.modalVisualizarSugestaoEdicao = true
    },
    loadModalPriorizar(index) {
      this.resourceAvaliacoes = 'proposta/' + this.form.propostas[index].id + '/visualizar/avaliacao'
      this.propostaAtual = this.form.propostas[index].id
      this.filtros.proposta_original = true
      this.modalPriorizar = true
      this.propostaPrioriazada = this.form.propostas[index]
    },
    loadCaderno() {
      Vue.http.get('api/proposta/' + this.$route.params.id).then(response => {
        let data = response.body.data

        this.form.id = data.id
        this.form.titulo = data.titulo
        this.form.descricao = data.descricao
        this.form.propostas = data.propostas
        this.form.comentarios = data.comentarios
        this.form.acao_aprovar = data.acao_aprovar
        this.form.acao_editar = data.acao_editar
        this.form.acao_emenda = data.acao_emenda
        this.form.acao_priorizar = data.acao_priorizar
        this.form.priorizar_max = data.priorizar_max
        this.form.situacao = data.situacao
        this.form.visivel_encerrado = data.visivel_encerrado
        this.form.emendas = data.emendas

        this.load = true

        let alternativa_selecionada = null
        let pergunta_id = null
        let verifica_pergunta = null
        let verifica_alternativa = null
        let verifica_perfil = false
        if (data.acoesPerfilPergunta.length > 0) {
          for (let perfil in data.acoesPerfilPergunta) {
            alternativa_selecionada = data.acoesPerfilPergunta[perfil].alternativa_id
            pergunta_id = data.acoesPerfilPergunta[perfil].pergunta_id

            if (this.perguntas_respostas) {
              for (let index in this.perguntas_respostas) {
                if (this.perguntas_respostas[index].pergunta_id == pergunta_id) {
                  verifica_pergunta = true
                }
                if (this.perguntas_respostas[index].alternativa_id == alternativa_selecionada) {
                  verifica_alternativa = true
                }
              }

              if (verifica_pergunta && verifica_alternativa) {
                let acoes = data.acoesPerfilPergunta[perfil].acao
                let perfisId = data.acoesPerfilPergunta[perfil].perfil_id
                for (let per in perfisId) {
                  if (perfisId[per] == this.perfilUser) {
                    verifica_perfil = true
                    for (let acao in acoes) {
                      switch (acoes[acao].value) {
                        case 'S':
                          this.acao_perfil_editar = true
                          break;
                        case 'A':
                          this.acao_perfil_aprovar = true
                          break;
                        case 'P':
                          this.acao_perfil_priorizar = true
                          break;
                        case 'E':
                          this.acao_perfil_editar = true
                          break;
                      }
                    }
                  }
                }
                verifica_pergunta = null
                verifica_alternativa = null
              }
            }
          }
        }

        if (data.acoesPerfil && verifica_perfil == false) {
          for (let perfil in data.acoesPerfil) {
            if (data.acoesPerfil[perfil].length > 0) {
              if (this.perfilUser == perfil) {
                let perfilAcao = data.acoesPerfil[perfil]
                for (let acao in perfilAcao) {
                  switch (perfilAcao[acao]) {
                    case 'S':
                      this.acao_perfil_editar = true
                      break;
                    case 'A':
                      this.acao_perfil_aprovar = true
                      break;
                    case 'P':
                      this.acao_perfil_priorizar = true
                      break;
                    case 'E':
                      this.acao_perfil_editar = true
                  }
                }
              }
            }
          }
        }
   
        if(data.acoesPerfil && verifica_perfil ==  false){           
            for (let perfil in data.acoesPerfil) {         
              if(data.acoesPerfil[perfil].length > 0){  
                if (this.perfilUser == perfil){           
                let perfilAcao = data.acoesPerfil[perfil]
                for (let acao in perfilAcao){                               
                    switch (perfilAcao[acao]) {
                      case 'S':
                          this.acao_perfil_editar = true        
                      break;
                      case 'A':
                          this.acao_perfil_aprovar = true 
                      break;
                      case 'P':
                          this.acao_perfil_priorizar = true 
                      break;
                    }
                  }
                }            
              }     
            } 
        }
             
        for (let i in this.form.propostas) {
          if (this.form.propostas[i].totalPriorizacao == this.form.priorizar_max) {
            this.form.propostas[i].travaPriorizar = false
          } else {
            this.form.propostas[i].travaPriorizar = true
          }
        }

        if(this.indiceSugestao !== null){
          this.emendas = this.form.propostas[this.indiceSugestao].emendas
        }

        if(this.totalUser >= this.form.priorizar_max){
          this.travaPriorizar = false
        }else{
          this.travaPriorizar = true
        }
      })
    },
    buscaPermissoesFormulario() {
      Vue.http.get('api/formulario/buscarPermissoesFormulario/' + this.conferencia_id + '/' + this.usuario_id).then(response => {
        if (response.body.success) {
          let data = response.body.data.data
          if (data !== undefined) {
            this.perguntas_respostas = data.respostas.perguntas_respostas
          }
        }
        this.loadCaderno()
      })
    },
    enviarComentario() {

      if (this.comentario == '' || this.comentario == null) {
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error('Campo mensagem e obrigatório!', 'Alerta', 5000)
        return false
      }

      this.$bvModal.msgBoxConfirm('Confirma o envio da mensagem?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          let data = {
            texto: this.comentario,
            caderno_proposta_id: this.form.id
          }
          this.show = true

          Vue.http.post('api/proposta/' + this.form.id + '/comentario', data).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.modalComentario = false
              this.comentario = ''
              this.loadCaderno()
            } else {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.show = false
            this.loading = false
          }).catch(e => {
            console.log('Servidor está fora! ' + e)
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    enviarSugestaoEdicao() {

      if(this.form.acao_emenda && !this.form.acao_editar){
        this.modalSugestaoEdicao = false
        return false
      }

      this.$bvModal.msgBoxConfirm('Confirma o envio da sugestão de alteração?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.show = true
          let data = {
            proposta_id: this.propostaAtual,
            texto: this.sugestaoEdicao
          }

          Vue.http.post('api/proposta/emenda', data).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.modalSugestaoEdicao = false
              this.propostaAtual = ''
              this.textoAtualSugestao = ''
              this.sugestaoEdicao = ''
              this.loadCaderno()
            } else {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.show = false
            this.loading = false
          }).catch(e => {
            console.log('Servidor está fora! ' + e)
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    aprovarEmenda(id) {
      this.$bvModal.msgBoxConfirm('Confirma a aprovação da emenda?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.show = true
          Vue.http.put('api/proposta/' + id + '/aprovar_emenda').then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              // this.modalSugestaoEdicao = false
              this.loadCaderno()
            } else {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.show = false
            this.loading = false
          }).catch(e => {
            console.log('Servidor está fora! ' + e)
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    rejeitarEmenda(id) {
      this.$bvModal.msgBoxConfirm('Confirma a rejeição da emenda?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.show = true
          Vue.http.put('api/proposta/' + id + '/rejeitar_emenda').then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              // this.modalSugestaoEdicao = false
              this.loadCaderno()
            } else {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.show = false
            this.loading = false
          }).catch(e => {
            console.log('Servidor está fora! ' + e)
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    cancelar() {
      this.modalSugestaoEdicao = false
      this.modalPriorizar = false
      this.modalAprovarOriginal = false
      this.modalAprovarAlterado = false
    },
    aprovarPropostaOriginal() {
      // if (this.form.eixo === this.eixoUser) {
      this.$bvModal.msgBoxConfirm('Confirma a aprovação?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.loading = true
          this.show = true
          Vue.http.put('api/proposta/' + this.propostaOriginal.id + '/original/aprovada').then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success('Proposta aprovada!', 'Sucesso!', 7000)
            } else {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.show = false
            this.loading = false
            this.modalAprovarOriginal = false
            this.loadCaderno()
          }).catch(e => {
            console.log('Servidor está fora! ' + e)
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
      // }
    },
    aprovarPropostaAlterada() {
      this.$bvModal.msgBoxConfirm('Confirma a rejeição?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.show = true
          this.loading = true
          Vue.http.put('api/proposta/' + this.propostaAlterada.id + '/alterada/aprovada').then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success('Proposta aprovada!', 'Sucesso!', 7000)
            } else {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.show = false
            this.loading = false
            this.modalAprovarAlterado = false
            this.loadCaderno(this.$route.params.id)
          }).catch(e => {
            console.log('Servidor está fora! ' + e)
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    priorizarProposta() {
      this.$bvModal.msgBoxConfirm('Confirma a priorização?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.loading = true
          this.show = true
          Vue.http.put('api/proposta/' + this.propostaAtual + '/priorizada').then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
            } else {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.show = false
            this.loading = false
            this.modalPriorizar = false
            this.loadCaderno()
          }).catch(e => {
            miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
            miniToastr.error(e.body.msg, 'Alerta', 5000)
            
            this.show = false
            this.loading = false
            this.modalPriorizar = false
            this.loadCaderno()
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    loadModalAprovarOriginal(index) {
      this.resourceAvaliacoes = 'proposta/' + this.form.propostas[index].id + '/avaliacao'
      this.propostaAtual = this.form.propostas[index].id
      this.filtros.proposta_original = true
      this.modalAprovarOriginal = true
      this.propostaOriginal = this.form.propostas[index]
      this.propostaAlterada = this.form.propostas[index]
    },
    loadModalAprovarAlterado(index) {
      this.resourceAvaliacoes = 'proposta/' + this.form.propostas[index].id + '/avaliacao'
      this.propostaAtual = this.form.propostas[index].id
      this.filtros.proposta_original = false
      this.modalAprovarAlterado = true
      this.propostaOriginal = this.form.propostas[index]
      this.propostaAlterada = this.form.propostas[index]
    },
    setarFiltros(filtros) {
      eventType.$emit('app', filtros)
    },
    can(permissao) {
      // return this.$store.getters.validaPermissao(permissao)
      return true
    },
    navigate(route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/caderno/PropostaConsulta.vue